import cartData from '#shared/util/cartData.js';
import isObject from '#shared/util/isObject.js';

import cButton from '#themes/default/default/components/button/button.js';
import cHeader from '#themes/default/default/components/header/header.js';

import template from './error.html' with { type: 'html' };

export default {
	...cartData,
	name: 'CError',
	components: {
		cButton,
		cHeader
	},
	meta() {
		return {
			title: `${this.t('global_metaTitle')} - ${this.t('error_metaTitle')}`
		};
	},
	data() {
		return {
			invalidProduct: this.isProductError(['sku is invalid'/* GEN */, 'Cannot find internalId for foreignId'/* PP */])
		};
	},
	computed: {
		isDefault() {
			return isObject(this.theme) && this.theme.name === 'default';
		},
		reloadAvailable() {
			return this.retargetingUrl && (!this.invalidProduct || this.isEmpty);
		}
	},
	mounted() {
		this.utils.hideLoader();
		this.tracking.errorPageStatus({
			app: this.app,
			error: this.error,
			order: this.order,
			url: this.url,
			theme: this.theme,
			page: this.page
		});
	},
	methods: {
		isProductError(errorTypesArray) {
			return isObject(this.error) && errorTypesArray.some((errorType) => {
				return (this.error.message || '').includes(errorType);
			});
		}
	},
	template
};
